import * as z from "zod";

export const reactivateOms = {
  name: "reactivateOms" as const,
  input: z.object({ teamId: z.string() }),
  output: z.null(),
  description:
    "Reactivate OMS for a team that was marked inactive, restarting its inactivity grace period",
};
